export class ServiceType {
    constructor(public STID?, public STN?, public DID?, public DN?) { }
}